import { Translate } from 'react-redux-i18n'
import { store } from '../../../../../app/store'
import { getUnique } from '../../../../helpers/common'
import { selectPeriod } from '../../../../portfolioInsights/common/period/slice'
import { Chart } from '../../../../portfolioInsights/score/portfolioDistribution/Chart'
import { TableItem } from '../../../../portfolioInsights/score/portfolioDistribution/TableItem'
import {
  getDistributionCreditRisk,
  getDistributionPerformance,
} from '../../../../portfolioInsights/score/portfolioDistribution/store/thunk'
import { ScoreTrend } from '../../../../portfolioInsights/score/scoreTrend'
import { PopupEditScoreDynamic } from '../../../../portfolioInsights/score/scoreTrend/components/PopupEditScoreDynamic'
import {
  getPerformanceTrend,
  getRiskTrend,
} from '../../../../portfolioInsights/score/scoreTrend/store/thunk'
import {
  getScoreRangesCreditRisk,
  getScoreRangesPerformance,
} from '../../../../portfolioInsights/score/store/thunk'
import { TopCompanies } from '../../../../portfolioInsights/score/topCompanies'
import {
  getBiggestCreditRisk,
  getBiggestPerformance,
  getHighestCreditRisk,
  getHighestPerformance,
  getLargestDeclineCreditRisk,
  getLargestDeclinePerformance,
} from '../../../../portfolioInsights/score/topCompanies/store/thunk'
import { Chart as ChartTrendPort } from '../../../../portfolioInsights/score/trendByPortfolio/chart/index'
import {
  selectActivePortfolio,
  selectViewBy,
} from '../../../../portfolioInsights/score/trendByPortfolio/store/slice'
import {
  getTrendByPortfolioCreditRisk,
  getTrendByPortfolioPerformanceScore,
} from '../../../../portfolioInsights/score/trendByPortfolio/store/thunk'
import { TableTrendPort } from '../../../../portfolioInsights/score/trendByPortfolio/table'
import {
  MAIN_SCREEN,
  SCREEN,
  TYPE_INFORMATION_PANEL,
  TYPE_ITEM_SETTING,
  VIEW_BY,
} from '../../constant'
import ItemSelectPortfolio from '../../preferenceSetting/detailTemplate/settingPanel/information/ItemSelectPortfolio'
import { COMPARE_LEFT, COMPARE_RIGHT } from './finance'

export const KEY_DYNAMIC_SCORE = {
  SCORE: 'score',
  TIME_PERIOD: 'TIME_PERIOD',
  TOP_COMPANIES: 'TOP_COMPANIES',
  TREND_BY_PORT: 'TREND_BY_PORT',
}

export const VALUE_SCORE = {
  YEARLY: 'Yearly',
  QUARTERLY: 'Quarterly',
  MONTHLY: 'Monthly',
  HIGHEST_CREDIT_RISK: 'highestCreditRisk',
  BIGGEST_SCORE_CHANGES: 'biggestScoreChanges',
  LARGEST_DECLINE: 'largestDecline',
  FILTERED_PORTFOLIO: 'Filtered portfolio',
  LARGEST_PORT: 'Largest decline score in recent years',
  LOWEST_PORT: 'Lowest current score portfolio',
}

const PANEL_SETTING_PERIOD = {
  type: TYPE_INFORMATION_PANEL.NODE,
  renderItem: () => <Translate value="alerts.TIME_PERIOD" />,
  isInline: true,
  children: [
    {
      type: TYPE_INFORMATION_PANEL.RADIO,
      value: VALUE_SCORE.YEARLY,
      key: KEY_DYNAMIC_SCORE.TIME_PERIOD,
      title: 'companyAnalysis.industryAnalysis.YEARLY',
    },
    {
      type: TYPE_INFORMATION_PANEL.RADIO,
      value: VALUE_SCORE.QUARTERLY,
      key: KEY_DYNAMIC_SCORE.TIME_PERIOD,
      title: 'companyAnalysis.industryAnalysis.QUARTERLY',
    },
    {
      type: TYPE_INFORMATION_PANEL.RADIO,
      value: VALUE_SCORE.MONTHLY,
      key: KEY_DYNAMIC_SCORE.TIME_PERIOD,
      title: 'companyAnalysis.industryAnalysis.MONTHLY',
    },
  ],
}

const SETTING_TOP_10_COMPANIES = [
  {
    ...PANEL_SETTING_PERIOD,
  },
  {
    type: TYPE_INFORMATION_PANEL.CHECKBOX,
    value: VALUE_SCORE.HIGHEST_CREDIT_RISK,
    key: KEY_DYNAMIC_SCORE.TOP_COMPANIES,
    title: `portfolioScore.${VALUE_SCORE.HIGHEST_CREDIT_RISK}`,
  },
  {
    type: TYPE_INFORMATION_PANEL.CHECKBOX,
    value: VALUE_SCORE.BIGGEST_SCORE_CHANGES,
    key: KEY_DYNAMIC_SCORE.TOP_COMPANIES,
    title: `portfolioScore.${VALUE_SCORE.BIGGEST_SCORE_CHANGES}`,
  },
  {
    type: TYPE_INFORMATION_PANEL.CHECKBOX,
    value: VALUE_SCORE.LARGEST_DECLINE,
    key: KEY_DYNAMIC_SCORE.TOP_COMPANIES,
    title: `portfolioScore.${VALUE_SCORE.LARGEST_DECLINE}`,
  },
]

const SETTING_TREND_BY_PORT = [
  { ...PANEL_SETTING_PERIOD },
  {
    type: TYPE_INFORMATION_PANEL.CHECKBOX,
    value: VALUE_SCORE.FILTERED_PORTFOLIO,
    key: KEY_DYNAMIC_SCORE.TREND_BY_PORT,
    title: 'portfolioScore.namePortById.1',
    isRequire: true,
  },
  {
    type: TYPE_INFORMATION_PANEL.CHECKBOX,
    value: VALUE_SCORE.LARGEST_PORT,
    key: KEY_DYNAMIC_SCORE.TREND_BY_PORT,
    title: 'portfolioScore.namePortById.2',
  },
  {
    type: TYPE_INFORMATION_PANEL.CHECKBOX,
    value: VALUE_SCORE.LOWEST_PORT,
    key: KEY_DYNAMIC_SCORE.TREND_BY_PORT,
    title: 'portfolioScore.namePortById.3',
  },
]

const PANELS = {
  RISK_TREND: 'riskTrend',
  PERFORMANCE_TREND: 'performanceTrend',
  CREDIT_SCORE_TREND: 'creditScoreTrend',
  PERFORMANCE_SCORE_TREND: 'performanceScoreTrend',
  TOP_10_COMPANIES: 'top10Companies',
  TOP_10_COMPANIES_BY_GROWTH_POTENTIAL: 'top10CompaniesByGrowthPotential',
  PORTFOLIO_DISTRIBUTION: 'portfolioDistribution',
  PORTFOLIO_DISTRIBUTION_BY_GROWTH_POTENTIAL:
    'portfolioDistributionByGrowthPotential',
}

export const getPanelListScore = () => {
  return [
    {
      label: 'dynamicReport.SCORE_2',
      children: [
        {
          screen: SCREEN[MAIN_SCREEN.PORTFOLIO_INSIGHT].SCORE,
          panel: PANELS.RISK_TREND,
          label: 'dynamicReport.RISK_TREND',
          type: TYPE_ITEM_SETTING.PANEL,
          setting: {
            [KEY_DYNAMIC_SCORE.TIME_PERIOD]: VALUE_SCORE.YEARLY,
          },
        },
        {
          screen: SCREEN[MAIN_SCREEN.PORTFOLIO_INSIGHT].SCORE,
          panel: PANELS.PORTFOLIO_DISTRIBUTION,
          label: 'dynamicReport.PORTFOLIO_DISTRIBUTION',
          type: TYPE_ITEM_SETTING.PANEL,
          setting: {
            viewBy: VIEW_BY.TABLE,
            [KEY_DYNAMIC_SCORE.TIME_PERIOD]: VALUE_SCORE.YEARLY,
          },
        },
        {
          screen: SCREEN[MAIN_SCREEN.PORTFOLIO_INSIGHT].SCORE,
          panel: PANELS.TOP_10_COMPANIES,
          label: 'dynamicReport.TOP_10_COMPANIES',
          type: TYPE_ITEM_SETTING.PANEL,
          setting: {
            [KEY_DYNAMIC_SCORE.TOP_COMPANIES]: [
              VALUE_SCORE.HIGHEST_CREDIT_RISK,
              VALUE_SCORE.BIGGEST_SCORE_CHANGES,
              VALUE_SCORE.LARGEST_DECLINE,
            ],
            [KEY_DYNAMIC_SCORE.TIME_PERIOD]: VALUE_SCORE.YEARLY,
          },
        },
        {
          screen: SCREEN[MAIN_SCREEN.PORTFOLIO_INSIGHT].SCORE,
          panel: PANELS.CREDIT_SCORE_TREND,
          label: 'dynamicReport.CREDIT_SCORE_TREND',
          type: TYPE_ITEM_SETTING.PANEL,
          setting: {
            viewBy: VIEW_BY.CHART,
            [KEY_DYNAMIC_SCORE.TIME_PERIOD]: VALUE_SCORE.YEARLY,
            [KEY_DYNAMIC_SCORE.TREND_BY_PORT]: [
              VALUE_SCORE.FILTERED_PORTFOLIO,
              VALUE_SCORE.LOWEST_PORT,
              VALUE_SCORE.LARGEST_PORT,
            ],
            [PANELS.CREDIT_SCORE_TREND + COMPARE_LEFT]: {
              isChecked: false,
              selectValue: undefined,
            },
            [PANELS.CREDIT_SCORE_TREND + COMPARE_RIGHT]: {
              isChecked: false,
              selectValue: undefined,
            },
          },
        },
        {
          screen: SCREEN[MAIN_SCREEN.PORTFOLIO_INSIGHT].SCORE,
          panel: PANELS.PERFORMANCE_TREND,
          label: 'dynamicReport.PERFORMANCE_TREND',
          type: TYPE_ITEM_SETTING.PANEL,
          setting: {
            [KEY_DYNAMIC_SCORE.TIME_PERIOD]: VALUE_SCORE.YEARLY,
          },
        },
        {
          screen: SCREEN[MAIN_SCREEN.PORTFOLIO_INSIGHT].SCORE,
          panel: PANELS.PORTFOLIO_DISTRIBUTION_BY_GROWTH_POTENTIAL,
          label: 'dynamicReport.PORTFOLIO_DISTRIBUTION_BY_GROWTH_POTENTIAL',
          type: TYPE_ITEM_SETTING.PANEL,
          setting: {
            viewBy: VIEW_BY.TABLE,
            [KEY_DYNAMIC_SCORE.TIME_PERIOD]: VALUE_SCORE.YEARLY,
          },
        },

        {
          screen: SCREEN[MAIN_SCREEN.PORTFOLIO_INSIGHT].SCORE,
          panel: PANELS.TOP_10_COMPANIES_BY_GROWTH_POTENTIAL,
          label: 'dynamicReport.TOP_10_COMPANIES_BY_GROWTH_POTENTIAL',
          type: TYPE_ITEM_SETTING.PANEL,
          setting: {
            [KEY_DYNAMIC_SCORE.TOP_COMPANIES]: [
              VALUE_SCORE.HIGHEST_CREDIT_RISK,
              VALUE_SCORE.BIGGEST_SCORE_CHANGES,
              VALUE_SCORE.LARGEST_DECLINE,
            ],
            [KEY_DYNAMIC_SCORE.TIME_PERIOD]: VALUE_SCORE.YEARLY,
          },
        },

        {
          screen: SCREEN[MAIN_SCREEN.PORTFOLIO_INSIGHT].SCORE,
          panel: PANELS.PERFORMANCE_SCORE_TREND,
          label: 'dynamicReport.PERFORMANCE_SCORE_TREND',
          type: TYPE_ITEM_SETTING.PANEL,
          setting: {
            viewBy: VIEW_BY.CHART,
            [KEY_DYNAMIC_SCORE.TIME_PERIOD]: VALUE_SCORE.YEARLY,
            [KEY_DYNAMIC_SCORE.TREND_BY_PORT]: [
              VALUE_SCORE.FILTERED_PORTFOLIO,
              VALUE_SCORE.LOWEST_PORT,
              VALUE_SCORE.LARGEST_PORT,
            ],
            [PANELS.PERFORMANCE_SCORE_TREND + COMPARE_LEFT]: {
              isChecked: false,
              selectValue: undefined,
            },
            [PANELS.PERFORMANCE_SCORE_TREND + COMPARE_RIGHT]: {
              isChecked: false,
              selectValue: undefined,
            },
          },
        },
      ],
    },
  ]
}

export const getPanelScore = (panel, setting) => {
  const { viewBy } = setting
  const leftKey = panel + COMPARE_LEFT
  const rightKey = panel + COMPARE_RIGHT
  const { [leftKey]: leftSetting, [rightKey]: rightSetting } = setting
  const otherParam = {
    portfolioId1: leftSetting?.isChecked ? leftSetting?.selectValue : undefined,
    portfolioId2: rightSetting?.isChecked
      ? rightSetting?.selectValue
      : undefined,
  }
  const topCompaniesSettings = setting['TOP_COMPANIES'] || []

  switch (panel) {
    case PANELS.RISK_TREND:
      return {
        renderComponent: () => {
          return (
            <ScoreTrend isDynamicReport settingDynamic={setting} type={3} />
          )
        },
        width: 800,
        thunk: [
          ({ portfolioParams }) =>
            getRiskTrend({
              ...portfolioParams,
              timeFrequency: setting['TIME_PERIOD'],
            }),
          () => getScoreRangesCreditRisk({ NeedUndetermine: true }),
          () => getScoreRangesPerformance({ NeedUndetermine: true }),
        ],
        settingPanel: {
          items: [
            {
              ...PANEL_SETTING_PERIOD,
              renderCustomInformation: () => <PopupEditScoreDynamic type={3} />,
            },
          ],
        },
        isWaitForMount: true,
        isTable: true,
      }
    case PANELS.PERFORMANCE_TREND:
      return {
        renderComponent: () => {
          return (
            <ScoreTrend isDynamicReport settingDynamic={setting} type={2} />
          )
        },
        width: 800,
        thunk: [
          ({ portfolioParams }) =>
            getPerformanceTrend({
              ...portfolioParams,
              timeFrequency: setting['TIME_PERIOD'],
            }),
          () => getScoreRangesCreditRisk({ NeedUndetermine: true }),
          () => getScoreRangesPerformance({ NeedUndetermine: true }),
        ],
        settingPanel: {
          items: [
            {
              ...PANEL_SETTING_PERIOD,
              renderCustomInformation: () => <PopupEditScoreDynamic type={2} />,
            },
          ],
        },
        isWaitForMount: true,
        isTable: true,
      }

    case PANELS.PORTFOLIO_DISTRIBUTION:
      return {
        renderComponent: () => {
          return viewBy === VIEW_BY.TABLE ? (
            <TableItem isDynamicReport type={3} />
          ) : (
            <Chart isDynamicReport type={3} />
          )
        },
        width: 797,
        thunk: [
          () => getScoreRangesCreditRisk({ NeedUndetermine: true }),
          () => getScoreRangesPerformance({ NeedUndetermine: true }),
          ({ portfolioParams }) =>
            getDistributionCreditRisk({
              ...portfolioParams,
              timeFrequency: setting['TIME_PERIOD'],
            }),
        ],
        isWaitForMount: true,
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TABLE, VIEW_BY.CHART],
          [VIEW_BY.CHART]: [
            {
              ...PANEL_SETTING_PERIOD,
            },
          ],
          [VIEW_BY.TABLE]: [
            {
              ...PANEL_SETTING_PERIOD,
            },
          ],
        },
      }
    case PANELS.PORTFOLIO_DISTRIBUTION_BY_GROWTH_POTENTIAL:
      return {
        renderComponent: () => {
          return viewBy === VIEW_BY.TABLE ? (
            <TableItem isDynamicReport type={2} />
          ) : (
            <Chart isDynamicReport type={2} />
          )
        },
        thunk: [
          () => getScoreRangesCreditRisk({ NeedUndetermine: true }),
          () => getScoreRangesPerformance({ NeedUndetermine: true }),
          ({ portfolioParams }) =>
            getDistributionPerformance({
              ...portfolioParams,
              timeFrequency: setting['TIME_PERIOD'],
            }),
        ],
        isWaitForMount: true,
        isTable: viewBy === VIEW_BY.TABLE,
        width: 797,
        settingPanel: {
          viewByList: [VIEW_BY.TABLE, VIEW_BY.CHART],
          [VIEW_BY.CHART]: [
            {
              ...PANEL_SETTING_PERIOD,
            },
          ],
          [VIEW_BY.TABLE]: [
            {
              ...PANEL_SETTING_PERIOD,
            },
          ],
        },
      }
    case PANELS.TOP_10_COMPANIES:
      return {
        components: topCompaniesSettings.map((value) => () => (
          <TopCompanies
            isDynamicReport
            settings={topCompaniesSettings}
            boxKey={value}
            type={3}
          />
        )),
        thunk: [
          ({ portfolioParams }) =>
            getHighestCreditRisk({
              timeFrequency: setting['TIME_PERIOD'],
              limit: 10,
              ...portfolioParams,
            }),
          ({ portfolioParams }) =>
            getBiggestCreditRisk({
              timeFrequency: setting['TIME_PERIOD'],
              limit: 10,
              ...portfolioParams,
            }),
          ({ portfolioParams }) =>
            getLargestDeclineCreditRisk({
              timeFrequency: setting['TIME_PERIOD'],
              limit: 10,
              ...portfolioParams,
            }),
        ],
        isWaitForMount: true,
        isTable: true,
        settingPanel: { items: [...SETTING_TOP_10_COMPANIES] },
      }
    case PANELS.TOP_10_COMPANIES_BY_GROWTH_POTENTIAL:
      return {
        components: topCompaniesSettings.map((value) => () => (
          <TopCompanies
            isDynamicReport
            settings={topCompaniesSettings}
            boxKey={value}
            type={2}
          />
        )),
        thunk: [
          ({ portfolioParams }) =>
            getHighestPerformance({
              timeFrequency: setting['TIME_PERIOD'],
              limit: 10,
              ...portfolioParams,
            }),
          ({ portfolioParams }) =>
            getBiggestPerformance({
              timeFrequency: setting['TIME_PERIOD'],
              limit: 10,
              ...portfolioParams,
            }),
          ({ portfolioParams }) =>
            getLargestDeclinePerformance({
              timeFrequency: setting['TIME_PERIOD'],
              limit: 10,
              ...portfolioParams,
            }),
        ],
        isWaitForMount: true,
        isTable: true,
        settingPanel: {
          items: [...SETTING_TOP_10_COMPANIES],
        },
      }
    case PANELS.CREDIT_SCORE_TREND:
      return {
        renderComponent: () => {
          return viewBy === VIEW_BY.TABLE ? (
            <TableTrendPort
              isDynamicReport
              portfolio1={setting['creditScoreTrend1']}
              portfolio2={setting['creditScoreTrend2']}
              checkTypePort={setting['TREND_BY_PORT']}
              timePeriod={setting['TIME_PERIOD']}
              type={3}
            />
          ) : (
            <ChartTrendPort
              isDynamicReport
              portfolio1={setting['creditScoreTrend1']}
              portfolio2={setting['creditScoreTrend2']}
              checkTypePort={setting['TREND_BY_PORT']}
              timePeriod={setting['TIME_PERIOD']}
              type={3}
            />
          )
        },
        width: 800,
        thunk: [
          () => getScoreRangesCreditRisk({ NeedUndetermine: true }),
          () => getScoreRangesPerformance({ NeedUndetermine: true }),
          ({ portfolioParams }) =>
            getTrendByPortfolioCreditRisk({
              ...portfolioParams,
              ...otherParam,
              timeFrequency: setting['TIME_PERIOD'],
            }),
        ],
        isWaitForMount: true,
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TABLE, VIEW_BY.CHART],
          [VIEW_BY.CHART]: [
            ...SETTING_TREND_BY_PORT,
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: ({ key, ...other }) => (
                <ItemSelectPortfolio
                  keySetting={leftKey}
                  {...other}
                  style={{ padding: 0 }}
                />
              ),
            },

            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: ({ key, ...other }) => (
                <ItemSelectPortfolio
                  keySetting={rightKey}
                  {...other}
                  style={{ padding: 0 }}
                />
              ),
            },
          ],
          [VIEW_BY.TABLE]: [
            ...SETTING_TREND_BY_PORT,
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: ({ key, ...other }) => (
                <ItemSelectPortfolio
                  keySetting={leftKey}
                  {...other}
                  style={{ padding: 0 }}
                />
              ),
            },

            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: ({ key, ...other }) => (
                <ItemSelectPortfolio
                  keySetting={rightKey}
                  {...other}
                  style={{ padding: 0 }}
                />
              ),
            },
          ],
        },
      }
    case PANELS.PERFORMANCE_SCORE_TREND:
      return {
        renderComponent: () => {
          return viewBy === VIEW_BY.TABLE ? (
            <TableTrendPort
              isDynamicReport
              portfolio1={setting['performanceScoreTrend1']}
              portfolio2={setting['performanceScoreTrend2']}
              checkTypePort={setting['TREND_BY_PORT']}
              timePeriod={setting['TIME_PERIOD']}
              type={2}
            />
          ) : (
            <ChartTrendPort
              isDynamicReport
              portfolio1={setting['performanceScoreTrend1']}
              portfolio2={setting['performanceScoreTrend2']}
              checkTypePort={setting['TREND_BY_PORT']}
              timePeriod={setting['TIME_PERIOD']}
              type={2}
            />
          )
        },
        width: 800,
        thunk: [
          () => getScoreRangesCreditRisk({ NeedUndetermine: true }),
          () => getScoreRangesPerformance({ NeedUndetermine: true }),
          ({ portfolioParams }) =>
            getTrendByPortfolioPerformanceScore({
              ...portfolioParams,
              ...otherParam,
              timeFrequency: setting['TIME_PERIOD'],
            }),
        ],
        isWaitForMount: true,
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TABLE, VIEW_BY.CHART],
          [VIEW_BY.CHART]: [
            ...SETTING_TREND_BY_PORT,

            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: ({ key, ...other }) => (
                <ItemSelectPortfolio
                  keySetting={leftKey}
                  {...other}
                  style={{ padding: 0 }}
                />
              ),
            },

            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: ({ key, ...other }) => (
                <ItemSelectPortfolio
                  keySetting={rightKey}
                  {...other}
                  style={{ padding: 0 }}
                />
              ),
            },
          ],
          [VIEW_BY.TABLE]: [
            ...SETTING_TREND_BY_PORT,
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: ({ key, ...other }) => (
                <ItemSelectPortfolio
                  keySetting={leftKey}
                  {...other}
                  style={{ padding: 0 }}
                />
              ),
            },
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: ({ key, ...other }) => (
                <ItemSelectPortfolio
                  keySetting={rightKey}
                  {...other}
                  style={{ padding: 0 }}
                />
              ),
            },
          ],
        },
      }

    default:
      break
  }
}

export const getDefaultScore = () => {
  const period = selectPeriod(store.getState())
  const portfolio1 = selectActivePortfolio('activePortfolio1')(store.getState())
  const portfolio2 = selectActivePortfolio('activePortfolio2')(store.getState())
  const selectViewByTrendPort = selectViewBy(store.getState())

  const settingByKey = {
    [PANELS.RISK_TREND]: {
      [KEY_DYNAMIC_SCORE.TIME_PERIOD]: period,
    },
    [PANELS.PERFORMANCE_TREND]: {
      [KEY_DYNAMIC_SCORE.TIME_PERIOD]: period,
    },
    [PANELS.PORTFOLIO_DISTRIBUTION]: {
      viewBy: VIEW_BY.TABLE,
      [KEY_DYNAMIC_SCORE.TIME_PERIOD]: period,
    },
    [PANELS.PORTFOLIO_DISTRIBUTION_BY_GROWTH_POTENTIAL]: {
      viewBy: VIEW_BY.TABLE,
      [KEY_DYNAMIC_SCORE.TIME_PERIOD]: period,
    },
    [PANELS.TOP_10_COMPANIES]: {
      [KEY_DYNAMIC_SCORE.TOP_COMPANIES]: [
        VALUE_SCORE.HIGHEST_CREDIT_RISK,
        VALUE_SCORE.BIGGEST_SCORE_CHANGES,
        VALUE_SCORE.LARGEST_DECLINE,
      ],
      [KEY_DYNAMIC_SCORE.TIME_PERIOD]: period,
    },
    [PANELS.TOP_10_COMPANIES_BY_GROWTH_POTENTIAL]: {
      [KEY_DYNAMIC_SCORE.TOP_COMPANIES]: [
        VALUE_SCORE.HIGHEST_CREDIT_RISK,
        VALUE_SCORE.BIGGEST_SCORE_CHANGES,
        VALUE_SCORE.LARGEST_DECLINE,
      ],
      [KEY_DYNAMIC_SCORE.TIME_PERIOD]: period,
    },
    [PANELS.CREDIT_SCORE_TREND]: {
      viewBy: selectViewByTrendPort.value,
      [KEY_DYNAMIC_SCORE.TIME_PERIOD]: period,
      [KEY_DYNAMIC_SCORE.TREND_BY_PORT]: [
        VALUE_SCORE.FILTERED_PORTFOLIO,
        VALUE_SCORE.LOWEST_PORT,
        VALUE_SCORE.LARGEST_PORT,
      ],
      [PANELS.CREDIT_SCORE_TREND + COMPARE_LEFT]: {
        isChecked: !!portfolio1?.value,
        selectValue: portfolio1?.value,
      },
      [PANELS.CREDIT_SCORE_TREND + COMPARE_RIGHT]: {
        isChecked: !!portfolio2?.value,
        selectValue: portfolio2?.value,
      },
    },
    [PANELS.PERFORMANCE_SCORE_TREND]: {
      viewBy: selectViewByTrendPort.value,
      [KEY_DYNAMIC_SCORE.TIME_PERIOD]: period,
      [KEY_DYNAMIC_SCORE.TREND_BY_PORT]: [
        VALUE_SCORE.FILTERED_PORTFOLIO,
        VALUE_SCORE.LOWEST_PORT,
        VALUE_SCORE.LARGEST_PORT,
      ],
      [PANELS.PERFORMANCE_SCORE_TREND + COMPARE_LEFT]: {
        isChecked: !!portfolio1?.value,
        selectValue: portfolio1?.value,
      },
      [PANELS.PERFORMANCE_SCORE_TREND + COMPARE_RIGHT]: {
        isChecked: !!portfolio2?.value,
        selectValue: portfolio2?.value,
      },
    },
  }

  return getPanelListScore()[0].children.map((panel) => ({
    id: getUnique(),
    ...panel,
    setting: settingByKey[panel.panel],
  }))
}
